/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex'
import { moduleGetterContext, moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
import * as types from '@/lib/definition/types'
import moment from "moment-timezone";
moment.locale('ja')
import { Octokit } from "@octokit/core";
import { Endpoints } from "@octokit/types";

export interface PersonalTimeState {
  [key: string]: any;
}

const PersonalTime = defineModule({
  state: (): PersonalTimeState => {
    return {
    }
  },
  getters: {
    emptyChangeProjectParam: (...args): types.ChangeProjectParam => {
      return {
        personalTimeCurrentId: null,
        appUserId: '',
        projectId: null,
        projectRepositoryId: null,
        issueNumber: null,
        note: '',
        issueName: '',
        isActive: true,
        projects: [],
        milestoneId: null,
        milestoneTitle: ''
      }
    },
  },
  mutations: {
    SET_VALUE (state, param: { name: string; value: any }) {
      state[param.name] = param.value
    }
  },
  actions: {
    async getChangeProjectParam(context): Promise<types.ChangeProjectParam> {
      const { rootState, commit } = moduleActionContext(context, PersonalTime)
      const retval = await Lib.Ajax.getHandleError<types.DataResponse<types.ChangeProjectParam>>('/api/personaltime/listchangeproject', "クライアントの取得に失敗しました", {}, rootState.Login.accessToken)
      var list = retval.data.data
      commit.SET_VALUE({name: 'Clietns', value: list})
      return list
    },
    async getChangeProjectParamForIssue(context, personalTimeDayProjectIssueId: string): Promise<types.ChangeProjectParam> {
      const { rootState, commit } = moduleActionContext(context, PersonalTime)
      const retval = await Lib.Ajax.getHandleError<types.DataResponse<types.ChangeProjectParam>>('/api/personaltime/listchangeproject/' + personalTimeDayProjectIssueId, "クライアントの取得に失敗しました", {}, rootState.Login.accessToken)
      var list = retval.data.data
      commit.SET_VALUE({name: 'Clietns', value: list})
      return list
    },    async accessDayParam(context, date:string): Promise<types.PersonalTimeDayParam> {
      const { rootState, commit } = moduleActionContext(context, PersonalTime)
      const retval = await Lib.Ajax.getHandleError<types.DataResponse<types.PersonalTimeDayParam>>('/api/personaltime/accessday', "プロジェクトの取得に失敗しました", {day: date}, rootState.Login.accessToken)
      var list = retval.data.data
      commit.SET_VALUE({name: 'Clietns', value: list})
      return list
    },
    async personalReport(context, payload: {startDate: string, endDate:string }): Promise<types.PersonalTimeTotalReport[]> {
      const { rootState, commit } = moduleActionContext(context, PersonalTime)
      const retval = await Lib.Ajax.getHandleError<types.DataResponse<types.PersonalTimeTotalReport[]>>('/api/personaltime/personalreport/' + payload.startDate + '/' + payload.endDate, "プロジェクト時間の取得に失敗しました", {}, rootState.Login.accessToken)
      var list = retval.data.data
      return list
    },
    async getGithubRepositoryIssues(context, repo_info: {org:string, repo:string, state:"open" | "closed" | "all"}) : Promise<Endpoints["GET /repos/{owner}/{repo}/issues"]["response"]["data"]> {
      const { dispatch, rootState, commit } = moduleActionContext(context, PersonalTime)
      type Response = Endpoints["GET /repos/{owner}/{repo}/issues"]["response"];
      type Parameters = Endpoints["GET /repos/{owner}/{repo}/issues"]["parameters"];
      let token = rootState.Login.userInfo.githubUserToken
      var issues: any[] = []
      const octokit = new Octokit({auth:token})
      var page = 1
      do {
        let param:Parameters = {owner: repo_info.org, repo: repo_info.repo , state: repo_info.state,per_page:100,page:page,sort:"updated",direction:"desc"}
        const response: Response = await octokit.request("GET /repos/{owner}/{repo}/issues", param);
        response.data.forEach(obj => {
          issues.push(obj)
        })
        if (response.data.length < 100) {
          break;
        }
        page++
      // eslint-disable-next-line no-constant-condition
      } while(true)
      return issues
    },
    async makeActive(context, payload: types.ChangeProjectParam): Promise<boolean> {
      const { rootState, dispatch } = moduleActionContext(context, PersonalTime)
      var param = Object.assign({}, payload) as unknown as {[key: string]: string;}
      param.projects = ''
      param.note = param.note ?? ''
      param.issueName = param.issueNumber == null ? '' : param.issueName
      param.issueNumber = param.issueNumber == undefined ? '' : param.issueNumber
      param.milestoneId = param.milestoneId ?? ''
      param.projectRepositoryId = param.projectRepositoryId ?? ''
      param.personalTimeCurrentId = param.personalTimeCurrentId == null ? '' : param.personalTimeCurrentId
      const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/personaltime/submitchange', "アサインの設定に失敗しました。", param, rootState.Login.accessToken)
      var result = retval.data.data
      return result  
    },  
    async addProjectForDate(context, payload:{param: types.ChangeProjectParam, date: string}): Promise<boolean> {
      const { rootState, dispatch } = moduleActionContext(context, PersonalTime)
      var param = Object.assign({}, payload.param) as unknown as { [key: string]: string; }
      param.projects = ''
      param.note = param.note ?? ''
      param.issueName = param.issueNumber == null ? '' : param.issueName
      param.milestoneId = param.milestoneId ?? '';
      param.issueNumber = param.issueNumber == undefined ? '' : param.issueNumber
      param.projectRepositoryId = param.projectRepositoryId ?? ''
      const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/personaltime/addproject/' + payload.date, "プロジェクトの追加に失敗しました。", param, rootState.Login.accessToken)
      var result = retval.data.data
      return result  
    },  
    async updateProjectIssue(context, payload:types.UpdateIssueParam): Promise<boolean> {
      const { rootState, dispatch } = moduleActionContext(context, PersonalTime)
      var param = Object.assign({}, payload) as unknown as {[key: string]: string;}
      param.note = param.note ?? ''
      param.issueName = param.issueNumber == null ? '' : param.issueName
      param.issueNumber = param.issueNumber == undefined ? '' : param.issueNumber
      param.milestoneId = param.milestoneId ?? ''
      param.milestoneTitle = param.milestoneTitle ?? ''
      param.projectRepositoryId = param.projectRepositoryId ?? ''
      const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/personaltime/updateissue', "プロジェクトの追加に失敗しました。", param, rootState.Login.accessToken)
      var result = retval.data.data
      return result  
    },  
    async updateIssueTime(context, payload: types.PersonalTimeDayProjectIssueParam): Promise<boolean> {
      const { rootState, dispatch } = moduleActionContext(context, PersonalTime)
      var param = Object.assign({}, payload) as unknown as { [key: string]: string; }
      param.totalSetSeconds = payload.totalSetSeconds == null ? '' : param.totalSetSeconds
      const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/personaltime/updateissuetime', "アサインの設定に失敗しました。", param, rootState.Login.accessToken)
      var result = retval.data.data
      return result  
    },  
    async deleteIssue(context, payload: types.PersonalTimeDayProjectIssueParam): Promise<boolean> {
      const { rootState, dispatch } = moduleActionContext(context, PersonalTime)
      var param = Object.assign({}, payload) as unknown as {[key: string]: string;}
      const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/personaltime/deleteissue', "プロジェクト詳細の削除に失敗しました。", param, rootState.Login.accessToken)
      var result = retval.data.data
      return result  
    },
  },
  namespaced: true
})

export default PersonalTime